/**
 * RequirePlatformAdmin.jsx — platform-admin JWT gate (admin: true).
 * Shaped by: patient prompt P1, owner 2026-10-12.
 * Invariants: isGlobalAdmin is the admin custom claim; org and regional
 *   admins do not pass; this is not the launcher catalog.
 * Related: GlobalAdminRoutes.jsx, Auth.js tokenClaims.admin.
 */
import React from "react";
import { Alert, Container } from "@mui/material";
import Loading from "components/Loading";
import { useAuth } from "hooks/useAuth";

export function RequirePlatformAdmin({ children }) {
  const { isGlobalAdmin, userLoading } = useAuth();

  if (userLoading) {
    return <Loading page />;
  }

  if (!isGlobalAdmin) {
    return (
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Alert severity="info" data-testid="platform-admin.denied">
          This app is not available for your account.
        </Alert>
      </Container>
    );
  }

  return children;
}

export default RequirePlatformAdmin;
